import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { API_URL } from "@/shared"
import { showNotification } from "@mantine/notifications"

export const useVisits = (filters?: { medico_id?: string; clinica_id?: string }) => {
  return useQuery({
    queryKey: ["medical-education-visits", filters],
    queryFn: async () => {
      try {
        const response = await axios.get(`${API_URL}/medical-education/visits`, { params: filters })
        return response.data.data
      } catch (err) {
        console.error("Error getting visits", err)
        showNotification({ title: "Error al obtener visitas", message: "No se pudieron cargar las visitas. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    }
  })
}

export const useCreateVisit = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (visitData: any) => {
      try {
        const response = await axios.post(`${API_URL}/medical-education/visits`, visitData)
        showNotification({ title: "Visita agregada", message: "La visita ha sido agregada exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error creating visit", err)
        showNotification({ title: "Error al agregar visita", message: "No se pudo agregar la visita. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-visits"] })
    }
  })
}

export const useUpdateVisit = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, visitData }: { id: string; visitData: any }) => {
      try {
        const response = await axios.put(`${API_URL}/medical-education/visits/${id}`, visitData)
        showNotification({ title: "Visita actualizada", message: "La visita ha sido actualizada exitosamente.", color: "green" })
        return response.data.data
      } catch (err) {
        console.error("Error updating visit", err)
        showNotification({ title: "Error al actualizar visita", message: "No se pudo actualizar la visita. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-visits"] })
    }
  })
}

export const useDeleteVisit = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const response = await axios.delete(`${API_URL}/medical-education/visits/${id}`)
        showNotification({ title: "Visita eliminada", message: "La visita ha sido eliminada exitosamente.", color: "green" })
        return response.data
      } catch (err) {
        console.error("Error deleting visit", err)
        showNotification({ title: "Error al eliminar visita", message: "No se pudo eliminar la visita. Inténtelo nuevamente.", color: "red" })
        throw err
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["medical-education-visits"] })
    }
  })
}
